export const webClientId = '467244263862-jtj9bh9nnohpbip1r0qscaplo1gr8hsp.apps.googleusercontent.com'